import { Option, Terminable } from "@opendaw/lib-std";
import { Events, ReservedShortcuts } from "@opendaw/lib-dom";
import { ContextMenu } from "./ContextMenu";
import { MenuItem } from "./MenuItems";
const CLIPBOARD_PREFIX = "OPENDAW:1:";
export var ClipboardManager;
(function (ClipboardManager) {
    let fallbackEntry = Option.None;
    const encode = (entry) => `${CLIPBOARD_PREFIX}${JSON.stringify(entry)}`;
    const decode = (text) => text.startsWith(CLIPBOARD_PREFIX)
        ? Option.tryCatch(() => JSON.parse(text.slice(CLIPBOARD_PREFIX.length)))
        : Option.None;
    ClipboardManager.install = (element, handler) => {
        const writeEntry = (entry) => {
            fallbackEntry = Option.wrap(entry);
            navigator.clipboard?.writeText(encode(entry)).catch(() => { });
        };
        const performCopy = () => handler.copy().ifSome(writeEntry);
        const performCut = () => handler.cut().ifSome(writeEntry);
        const performPaste = async () => {
            const text = await Option.async(navigator.clipboard.readText());
            const entry = text.flatMap(decode);
            if (entry.nonEmpty()) {
                handler.paste(entry.unwrap());
            }
            else {
                fallbackEntry.ifSome(entry => handler.paste(entry));
            }
        };
        return Terminable.many(Events.subscribe(element, "copy", (event) => {
            handler.copy().ifSome(entry => {
                event.preventDefault();
                fallbackEntry = Option.wrap(entry);
                event.clipboardData?.setData("text/plain", encode(entry));
            });
        }), Events.subscribe(element, "cut", (event) => {
            handler.cut().ifSome(entry => {
                event.preventDefault();
                fallbackEntry = Option.wrap(entry);
                event.clipboardData?.setData("text/plain", encode(entry));
            });
        }), Events.subscribe(element, "paste", (event) => {
            const text = event.clipboardData?.getData("text/plain") ?? "";
            const entry = decode(text);
            if (entry.nonEmpty()) {
                event.preventDefault();
                handler.paste(entry.unwrap());
            }
            else {
                fallbackEntry.ifSome(entry => {
                    event.preventDefault();
                    handler.paste(entry);
                });
            }
        }), ContextMenu.subscribe(element, async (collector) => {
            const { client } = collector;
            const text = await Option.async(navigator.clipboard.readText());
            const entry = text.flatMap(decode);
            const canPaste = entry.map(entry => handler.canPaste(entry, client))
                .unwrapOrElse(() => fallbackEntry
                .map(entry => handler.canPaste(entry, client)).unwrapOrElse(false));
            collector.addItems(MenuItem.default({
                label: "Cut",
                shortcut: ReservedShortcuts.Cut.format(),
                selectable: handler.canCut(client)
            }).setTriggerProcedure(performCut), MenuItem.default({
                label: "Copy",
                shortcut: ReservedShortcuts.Copy.format(),
                selectable: handler.canCopy(client)
            }).setTriggerProcedure(performCopy), MenuItem.default({
                label: "Paste",
                shortcut: ReservedShortcuts.Paste.format(),
                selectable: canPaste
            }).setTriggerProcedure(performPaste));
        }));
    };
})(ClipboardManager || (ClipboardManager = {}));
